import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	hasError: false,
	data: EMPTY_OBJECT,
	errorMessage: ''
}
const bookingReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		//LOGIN HANDLING
		case CONSTANTS.APPLY_PROMOCODE_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.APPLY_PROMOCODE_SUCCESS:
			return { ...state, loader: false, data: action.data, hasError: false, errorMessage: '' }
		case CONSTANTS.APPLY_PROMOCODE_FAILURE:
			return { ...state, loader: false, errorMessage: 'There is some Error' }

		// before payment  api 
		case CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS:
			return { ...state, loader: false, beforePaymentData: action.data, hasError: false, errorMessage: '' }
		case CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE:
			return { ...state, loader: false, errorMessage: action.errorMessage }

		//  nonce payment api 
		case CONSTANTS.NONCE_TYPE_PAYMENT_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.NONCE_TYPE_PAYMENT_SUCCESS:
			return { ...state, loader: false, beforePaymentData: action.data, hasError: false, errorMessage: '' }
		case CONSTANTS.NONCE_TYPE_PAYMENT_FAILURE:
			return { ...state, loader: false, errorMessage: action.errorMessage }

		// for the GET CARD LIST
		case CONSTANTS.GET_CARD_LIST_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.GET_CARD_LIST_SUCCESS:
			return { ...state, loader: false, cardDetails: action.data, hasError: false, current_page: action.data.current_page, per_page: action.data.per_page, total: action.data.total, errorMessage: '' }
		case CONSTANTS.GET_CARD_LIST_FAILURE:
			return { ...state, loader: false, hasError: true, errorMessage: 'There is some Error' }

		default:
			return state
	}
}

export default bookingReducer